/**
 * Central place for data-testid values used across the app.
 */
export const HOME = {
  emergentLink: "emergent-link",
  header: "app-header",
  refreshButton: "refresh-button",
  tabsRoot: "ranking-tabs",
  tabServidores: "tab-servidores",
  tabPoliticos: "tab-politicos",
  tabPoliticosDeputados: "tab-politicos-deputados",
  tabPoliticosSenadores: "tab-politicos-senadores",
  searchInput: "search-input",
  orgaoSelect: "orgao-select",
  partidoSelect: "partido-select",
  rankingTable: "ranking-table",
  rankingRow: "ranking-row",
  emptyState: "empty-state",
  refreshStatus: "refresh-status",
  overviewCard: "overview-card",
};

export const DETAIL = {
  root: "detail-root",
  backLink: "back-link",
  breakdownCard: "breakdown-card",
  totalCard: "total-card",
};
